import { CardProps } from '@mui/material';
import { ReactNode } from 'react';
import { KpiBaseCard, KpiCardSize } from './KpiBaseCard';

export interface KpiCardValueProps extends Omit<CardProps, 'title'> {
  /** Main KPI label displayed at the top of the card. */
  title: ReactNode;
  /** KPI value highlighted as the primary number. */
  value: ReactNode;
  /** Optional supportive text shown below the value. */
  subtitle?: ReactNode;
  /** Optional icon or visual indicator shown to the left of the title. */
  icon?: ReactNode;
  /** Optional help content shown in a tooltip (question icon at the top right). */
  help?: ReactNode;
  /** Layout density; defaults to `md`. */
  size?: KpiCardSize;
}

/**
 * Generic KPI card variant focused on a single value.
 * It keeps full-width behavior so it adapts naturally inside responsive MUI Grid layouts.
 */
export function KpiCardValue({
  title,
  value,
  subtitle,
  icon,
  help,
  size = 'md',
  sx,
  ...cardProps
}: KpiCardValueProps) {
  return (
    <KpiBaseCard
      title={title}
      headerLeft={icon}
      value={value}
      help={help}
      size={size}
      footer={subtitle ?? null}
      sx={sx}
      {...cardProps}
    />
  );
}
